<script lang="ts">
  interface Properties {
    name: string;
    color: string;
  }

  const { name, color }: Properties = $props();
</script>

<!-- Colored pill for a transit line name; consumers compute `color` via `lineColor` from src/lib/mode-colors. -->
<span class="line-badge" style:background={color}>{name}</span>
